import UploadAndTrack from "@/components/form/upload-and-track";

const UploadTrack = () => {
  return <UploadAndTrack />;
};

export default UploadTrack;